import { MessageSquare, Camera, Handshake } from "lucide-react";
import { useScrollAnimation, useStaggeredAnimation } from "@/hooks/useScrollAnimation";

const ConsumerHowItWorks = () => {
  const { ref: titleRef, isVisible: titleVisible } = useScrollAnimation<HTMLDivElement>();
  const { ref, visibleItems } = useStaggeredAnimation<HTMLDivElement>(3, 200);

  const steps = [
    {
      number: "1",
      icon: MessageSquare,
      title: "Contact Us",
      description: "Fill out a simple form with your property details and we'll reach out to discuss your goals"
    },
    {
      number: "2",
      icon: Camera,
      title: "We Market Your Property",
      description: "Professional listing on GoDyspo investor platform with photos and detailed information"
    },
    {
      number: "3",
      icon: Handshake,
      title: "Connect With Buyers",
      description: "We bring qualified buyers directly to you - you stay in control of the sale"
    }
  ];

  return (
    <section id="how-it-works" className="py-20 px-4">
      <div className="container mx-auto">
        <div ref={titleRef} className={`text-center mb-16 transition-all duration-700 ${titleVisible ? 'animate-fade-in' : 'opacity-0'}`}>
          <h2 className="text-4xl font-bold mb-4">How It Works</h2>
          <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Three simple steps to get your property in front of serious buyers
          </p>
        </div>
        
        <div ref={ref} className="grid md:grid-cols-3 gap-12 max-w-5xl mx-auto">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`text-center transition-all duration-500 ${
                visibleItems.includes(index) ? 'animate-scale-in' : 'opacity-0 scale-95'
              }`}
            >
              <div className="relative mb-6 inline-block">
                <div className="w-20 h-20 bg-[#ffd700] rounded-full flex items-center justify-center">
                  <step.icon className="h-10 w-10 text-[#080c14]" />
                </div>
                <div className="absolute -top-2 -right-2 w-8 h-8 bg-gray-800 border-2 border-[#ffd700] rounded-full flex items-center justify-center">
                  <span className="text-[#ffd700] font-bold">{step.number}</span>
                </div>
              </div>
              <h3 className="text-2xl font-semibold mb-3">{step.title}</h3>
              <p className="text-gray-400">{step.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ConsumerHowItWorks;
